let personPageIds = [
  'schoolId',
  'observationStatus',
  'toolId',
  'year'
];

personPageIds.forEach((id) => {
  $('#' + id).selectize();
});
